const authConstants = {
  TOKEN_REFRESH_REQUEST: 'TOKEN_REFRESH_REQUEST',
  TOKEN_REFRESH_SUCCESS: 'TOKEN_REFRESH_SUCCESS',
  TOKEN_REFRESH_FAILURE: 'TOKEN_REFRESH_FAILURE',
  INIT_PAGE_SET: 'INIT_PAGE_SET'
};

export default authConstants;
